import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DashboardHeader = styled(Typography)({
  variant: "header",
  fontWeight: "700",
  fontSize: "14px",
  textTransform: "uppercase",
  marginTop: "24px",
  marginBottom: "1rem",
  paddingLeft: "8px",
});
